/**
 * URL を anchor href として render しても安全か判定する。
 *
 * Backend (`CreateRunRequest.url: str | None = Field(max_length=2048)`) は scheme
 * を検証していないため、API を直接叩いて `javascript:` / `data:` 等を POST すると
 * storage に残り、後で UI が `<a href={url}>` で render したときに click 経由で
 * 実行できる。これを防ぐため http(s) のみを許可する。
 */
export function isSafeHttpUrl(url: string | null | undefined): boolean {
  if (!url) return false
  try {
    const u = new URL(url)
    return u.protocol === "http:" || u.protocol === "https:"
  } catch {
    return false
  }
}
